import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/layout.component';
import { NotFoundComponent } from './shared/pages/not-found/not-found.component';

export const routes: Routes = [
	{
		path: '',
		component: AppLayoutComponent,
		loadChildren: () => import('./layout/layout.routes'),
	},
	{
		path: 'notfound',
		children: [
			{
				path: '',
				loadChildren: () =>
					import('./shared/components/notfound/notfound.module').then((m) => m.NotfoundModule),
			},
		],
	},
	{
		path: '**',
		component: NotFoundComponent,
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			anchorScrolling: 'enabled',
			scrollPositionRestoration: 'enabled',
		}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
